/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import HTMLEditor from "../HTMLEditor";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class ReportTemplateEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            example: {
                name: 'Example Report Template'
            }
        }
    }

    async componentDidMount() {
 
        if (this.props.params.id) {
            await this.loadAsync(this.props.params.id);
        }
    }
    
    loadAsync = async (id) => {
        try {
            let j = await qreq.getAsync('/api/report-template/' + id);
            if (j.errorCode === 0) {
                this.setState({ item: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch {
            this.unkownErrorCallback();
        }
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    submit = async (e) => {
        try {
            e?.preventDefault();
            var j = await qreq.postAsync('/api/report-template/save', this.state.item);
            if (j.errorCode === 0) {
                this.success('Report Template saved');
                this.goBack();
            }
            else
                this.alert('Error saving Report Template');
        }
        catch (e) {
            this.alert(e);
        }
    }

    changeTemplate = (c, v) => {
        this.setState({ item: { ...this.state.item, [c]: v } });
    }


    render() {
        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1>Report Template</h1>
                <Card title="Basic Information">
                    <div className="row">
                        <div className="col-md-12">
                            <FormInput model={this.state.item} name="name" label="Name" required placeholder={this.state.example.name} onChange={this.change} />
                        </div>
                    </div>
                </Card>

                <Card title="Header">
                    <HTMLEditor value={this.state.item.header} onChange={(v) => this.changeTemplate('header', v)} />
                </Card>
                <Card title="Content">
                    <HTMLEditor value={this.state.item.content} onChange={(v) => this.changeTemplate('content', v)} />
                </Card>
                <Card title="Footer">
                    <HTMLEditor value={this.state.item.footer} onChange={(v) => this.changeTemplate('footer', v)} />
                </Card>

                <Card title="Settings">
                    <div className="row">
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isDisabled" label="Disable" type="switch" onChange={this.change} />
                            <small>Disable the Report Template completely from use.</small>
                        </div>
                    </div>
                </Card>
                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg"><Icon icon="faSave" /> Save</button>
                </AppActions>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(ReportTemplateEdit);